module.exports = __webpack_public_path__ + "img/wbg-logo.57336b20.png";